import { store } from '../../store/store';
/**
 * Initiation
 * @param {string} userID - set the EmailJS user ID
 * @param {string} origin - set the EmailJS origin
 */

export var init = function init(userID) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https://api.emailjs.com';
  store._userID = userID;
  store._origin = origin;
};